import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Container from '@mui/material/Container';
import { useHistory, useParams } from "react-router-dom";
import Canva from '../../components/Canva';
import NavCanva from '../../components/Impresion/NavCanva';
import { ImpresionContext } from '../../providers/Impresion';
import { PaginatorContext } from '../../providers/Paginator';
import {DrawerContext} from "../../components/navbar/DrawerContext"
import { Box, Button, ButtonGroup, Menu, CircularProgress, MenuItem, Stack, TextField, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useContext, useEffect } from 'react';
import { api } from '../../services/api';
import { notify } from "../../utils/notifyToast"
import { useState } from 'react';
import "../../components/Impresion/fuentes.css"
import NewDiseno from '../../components/Impresion/NewDiseno';
import DisenosGallery from '../../components/Impresion/DisenosGallery';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SelectTarifa from "../../components/Impresion/SelTarifa";
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import { Redo, Save, Undo } from '@mui/icons-material';

const Impresion = (setToggle = true) => {
  const {
    dimensionContainer,
    setDimensionContainer,
    typeTicket,
    setTypeTicket,
    ableUndo,
    ableRedo,
    setAbleUndo,
    setAbleRedo,
    indexHistory,
    setIndexHistory,
    setElements,
    isCreated,
    setIsCreated,
    elements,
    setEdited,
    setError,
    setSaved,
    history,
    setIndex,
  } = useContext(ImpresionContext);

  const { setIsToggled } = useContext(PaginatorContext);
  const {setDrawerOpen} = useContext(DrawerContext);
  const [eventoNombre, setEventoNombre] = useState(null);
  const [tarifaNombre, setTarifaNombre] = useState(null);
  const [tarifaId, setTarifaId] = useState(null);

  const [loading, setLoading] = useState(true);
  const [disenoId, setDisenoId] = useState(null);
  const [openNew, setOpenNew] = useState(false);
  const [showCanva, setShowCanva] = useState(false);
  const [saving, setSaving] = useState(false);
  const param = useParams();
  const historyBrowser = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openSelectTarifa, setOpenSelectTarifa] = useState(false);

  const [unit, setUnit] = useState("px");
  const PX_PER_CM = 96 / 2.54;

  // Controla header y body class según modo canvas vs galería
  useEffect(() => {
    const headers = document.getElementsByTagName('header');

    if (showCanva) {
      document.body.classList.add("no-padding-impresion");
      document.body.classList.remove("drawer-open");
      document.body.classList.remove("drawer-collapsed");
      setIsToggled(true);
      setDrawerOpen(false);
      for (let i = 0; i < headers.length; i++) {
        headers[i].style.display = 'none';
      }
    } else {
      document.body.classList.remove("no-padding-impresion");
      setIsToggled(false);
      for (let i = 0; i < headers.length; i++) {
        headers[i].style.display = 'block';
      }
    }

    return () => {
      document.body.classList.remove("no-padding-impresion");
    };
  }, [showCanva]);

  // Título y popstate — solo una vez al montar
  useEffect(() => {
    document.title = `Imprimir | PassGo`;
    window.addEventListener('popstate', HandleBackward);
    return () => {
      window.removeEventListener('popstate', HandleBackward);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const HandleBackward = () => {
    setIsToggled(false);
    const header = document.getElementsByTagName('header');
    for (let i = 0; i < header.length; i++) {
      header[i].style.display = 'block';
    }
    historyBrowser.push(`/eventos/${param.id}`);
  };

  const getDiseno = async (idDiseno) => {
    if (!idDiseno) return;
    setDisenoId(idDiseno);
    setIsCreated(true);
    setLoading(true);
    try {
      const response = await api.impresion.getDisenoByID(idDiseno);
      if (response.status === "error") {
        throw Error("Error al obtener el diseño: " + response.message);
      }
      const data = JSON.parse(response.data.diseno.json);
      setElements(data.elements);
      setDimensionContainer({ ...dimensionContainer, ...data.type });
      setTypeTicket(true);
      setIndex(1 + parseInt(data.elements?.reduce((max, element) => element.id > max ? element.id : max, 0)));
      setEventoNombre(response.data.diseno.evento.evento);
      setTarifaNombre(response.data.diseno.tarifa.concepto);
      setTarifaId(response.data.diseno.tarifa.id);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const HandleUndo = () => {
    setAbleRedo(true);
    if (indexHistory >= history.length - 1) {
      setAbleUndo(false);
      return;
    }
    const newIndexHistory = indexHistory + 1;
    const newElements = history[history.length - 1 - newIndexHistory];
    setElements(newElements);
    setIndexHistory(newIndexHistory);
    if (newIndexHistory >= history.length - 1) {
      setAbleUndo(false);
    }
  };

  const HandleRedo = () => {
    setAbleUndo(true);
    if (indexHistory <= 0) {
      setAbleRedo(false);
      return;
    }
    const newIndexHistory = indexHistory - 1;
    const newElements = history[history.length - 1 - newIndexHistory];
    setElements(newElements);
    setIndexHistory(newIndexHistory);
    if (newIndexHistory <= 0) {
      setAbleRedo(false);
    }
  };

  const handleMenuClose = () => setAnchorEl(null);
  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);

  const HandleGuardarComo = () => setOpenSelectTarifa(true);

  const handleTarifaConfirm = async (tarifaDestino) => {
    setOpenSelectTarifa(false);
    setSaving(true);
    try {
      if (!tarifaDestino) {
        await HandleEdit();
        return;
      }
      const response = await api.impresion.duplicar(param.id, disenoId, tarifaDestino.id);
      if (response.status === "success") {
        notify("success", "Diseño duplicado correctamente");
      } else {
        notify("error", "Error al duplicar el diseño: " + response.message);
      }
    } catch (err) {
      notify("error", "Ocurrió un error: " + err);
    } finally {
      setSaving(false);
    }
  };

  const HandleEdit = () => {
    return new Promise(async (resolve, reject) => {
      const newElements = elements?.map((element) => ({
        ...element,
        x: element.x,
        y: element.y,
        width: element.width,
        height: element.height,
        fontSize: element.fontSize,
      }));
      const data = { type: dimensionContainer, elements: newElements };
      setSaving(true);
      try {
        const response = await api.impresion.update(param.id, disenoId, JSON.stringify(data));
        if (response.status === "success") {
          setEdited(true);
          notify("success", "Se guardaron los cambios");
          resolve(response);
        } else {
          setError(true);
          notify("error", "No se guardaron los cambios");
          reject(new Error(response.message || "Error al actualizar"));
        }
      } catch (error) {
        console.error("❌ Error al actualizar:", error);
        notify("error", "No se guardaron los cambios");
        setError(true);
        reject(error);
      } finally {
        setSaving(false);
      }
    });
  };

  const SaveStage = () => {
    const newElements = elements?.map((element) => ({
      ...element,
      x: element.x,
      y: element.y,
      width: element.width,
      height: element.height,
      fontSize: element.fontSize,
    }));
    const data = { type: dimensionContainer, elements: newElements };
    const callApi = async () => {
      setSaving(true);
      try {
        const response = await api.impresion.create(param.id, disenoId, { json: JSON.stringify(data) });
        if (response.status === "success") {
          setIsCreated(true);
          setSaved(true);
          notify("success", "El diseño se creó con éxito");
        }
      } catch (error) {
        notify("error", "No se puede guardar el diseño");
      } finally {
        setSaving(false);
      }
    };
    callApi();
  };

  useEffect(() => {
    const handlePressKey = (event) => {
      if (event.ctrlKey && event.key === 'z') HandleUndo();
      if (event.ctrlKey && event.key === 'y') HandleRedo();
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        if (!isCreated) { SaveStage(); return; }
        HandleEdit();
      }
    };
    window.addEventListener('keydown', handlePressKey);
    return () => window.removeEventListener('keydown', handlePressKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elements]);

  const handleChangeSize = (event) => {
    const raw = parseFloat(event.target.value) || 0;
    const valueInPx = unit === "cm" ? raw * PX_PER_CM : raw;
    setDimensionContainer({ ...dimensionContainer, [event.target.name]: valueInPx });
  };

  if (showCanva && loading) {
    return <Loading />;
  }

  // ── MODO GALERÍA ── sin ningún Container wrapper para no interferir con el drawer
  if (!showCanva) {
    return (
      <>
        <DisenosGallery
          onEditar={(id) => { setLoading(true); getDiseno(id); setShowCanva(true); }}
          onNuevo={() => setOpenNew(true)}
        />
        {openNew && (
          <NewDiseno
            onClose={() => setOpenNew(false)}
            onCreate={(value) => { setShowCanva(true); getDiseno(value); }}
          />
        )}
      </>
    );
  }

  // ── MODO CANVAS ── full-screen con su propio container
  return (
    <Container maxWidth="xl" className="h-100 p-0">
      <NavCanva getDiseno={getDiseno} evento={eventoNombre} tarifa={tarifaNombre} idTarifa={tarifaId} />
      <Container
        maxWidth="xl"
        className="h-100 bg-dark-subtle"
        style={{ padding: "0 0 0 120px" }}
      >
        <Stack
          direction="row"
          spacing={1}
          sx={{ justifyContent: "space-between", alignItems: "center", padding: "1rem" }}
        >
          <Button
            startIcon={<ArrowBackIcon />}
            variant="contained"
            onClick={() => setShowCanva(false)}
          >
            Atras
          </Button>
          <Box>
            <Typography variant='h5'>
              {tarifaNombre ? tarifaNombre : "Nombre del diseño"}
            </Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Stack direction="row" gap={1} alignItems="center">
              <TextField
                label={`Ancho (${unit})`}
                size="small"
                name='width'
                value={
                  unit === "cm"
                    ? parseFloat((dimensionContainer.width / PX_PER_CM).toFixed(2)) || ""
                    : dimensionContainer.width || 100
                }
                onChange={handleChangeSize}
                sx={{ width: 110 }}
              />
              <TextField
                label={`Alto (${unit})`}
                size="small"
                name='height'
                value={
                  unit === "cm"
                    ? parseFloat((dimensionContainer.height / PX_PER_CM).toFixed(2)) || ""
                    : dimensionContainer.height || 50
                }
                onChange={handleChangeSize}
                sx={{ width: 110 }}
              />
              <ToggleButtonGroup
                value={unit}
                exclusive
                onChange={(_, val) => val && setUnit(val)}
                size="small"
              >
                <ToggleButton value="px">px</ToggleButton>
                <ToggleButton value="cm">cm</ToggleButton>
              </ToggleButtonGroup>
            </Stack>

            <Button variant="contained" disabled={!ableUndo} onClick={HandleUndo}>
              <Undo />
            </Button>
            <Button variant="contained" disabled={!ableRedo} onClick={HandleRedo}>
              <Redo />
            </Button>

            {isCreated ? (
              <>
                <ButtonGroup variant="contained" color="primary" disabled={saving}>
                  <Button
                    onClick={HandleEdit}
                    disabled={saving}
                    startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <Save />}                  >
                    Guardar
                  </Button>
                  <Button size="small" onClick={handleMenuClick} sx={{ px: 1 }}>
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
                <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                  <MenuItem onClick={HandleGuardarComo}>Guardar como...</MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                variant="contained"
                color='primary'
                onClick={SaveStage}
                disabled={saving || !disenoId}
                startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <Save />}
              >
                Guardar Diseño
              </Button>
            )}
          </Stack>
        </Stack>

        <SelectTarifa
          open={openSelectTarifa}
          onClose={() => setOpenSelectTarifa(false)}
          onConfirm={handleTarifaConfirm}
          onSave={HandleEdit}
          elements={elements}
          dimensionContainer={dimensionContainer}
        />

        <Canva
          id='canva'
          width={dimensionContainer.width}
          height={dimensionContainer.height}
          getDiseno={getDiseno}
          idTarifa={tarifaId}
        />
      </Container>
    </Container>
  );
};

export default Impresion;